import React, { createContext, ReactNode, useContext, useState } from 'react';

import { SharingMember } from '@models/User';

type ViewersContextType = {
    viewers: SharingMember[];
    setViewers: React.Dispatch<React.SetStateAction<SharingMember[]>>;
};

const ViewersContext = createContext<ViewersContextType | undefined>(undefined);

export const ViewersProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [viewers, setViewers] = useState<SharingMember[]>([]);

    return <ViewersContext.Provider value={{ viewers, setViewers }}>{children}</ViewersContext.Provider>;
};

export const useViewers = (): ViewersContextType => {
    const context = useContext(ViewersContext);
    if (context === undefined) {
        throw new Error('useViewers must be used within a ViewersProvider');
    }
    return context;
};

export const useOptionalViewers = (): ViewersContextType | undefined => {
    return useContext(ViewersContext);
};
